/**
 * @fileoverview added by tsickle
 * Generated from: src/firebase-remote-config-provider-options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright DagonMetric. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found under the LICENSE file in the root directory of this source tree.
 */
import { InjectionToken } from '@angular/core';
/**
 * @record
 */
export function FirebaseConfig() { }
if (false) {
    /** @type {?|undefined} */
    FirebaseConfig.prototype.apiKey;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.projectId;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.appId;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.authDomain;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.databaseURL;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.storageBucket;
    /** @type {?|undefined} */
    FirebaseConfig.prototype.messagingSenderId;
    /* Skipping unhandled member: [key: string]: string | undefined;*/
}
/**
 * @record
 */
export function FirebaseRemoteConfigSettings() { }
if (false) {
    /**
     * Defines the maximum age in milliseconds of an entry in the config cache before
     * it is considered stale. Defaults to 43200000 (Twelve hours).
     * @type {?|undefined}
     */
    FirebaseRemoteConfigSettings.prototype.minimumFetchIntervalMillis;
    /**
     * Defines the maximum amount of milliseconds to wait for a response when fetching
     * configuration from the Remote Config server. Defaults to 60000 (One minute).
     * @type {?|undefined}
     */
    FirebaseRemoteConfigSettings.prototype.fetchTimeoutMillis;
}
/**
 * @record
 */
export function FirebaseRemoteConfigProviderOptions() { }
if (false) {
    /** @type {?} */
    FirebaseRemoteConfigProviderOptions.prototype.firebaseConfig;
    /** @type {?|undefined} */
    FirebaseRemoteConfigProviderOptions.prototype.appName;
    /** @type {?|undefined} */
    FirebaseRemoteConfigProviderOptions.prototype.remoteConfigSettings;
    /** @type {?|undefined} */
    FirebaseRemoteConfigProviderOptions.prototype.throwIfLoadError;
    /** @type {?|undefined} */
    FirebaseRemoteConfigProviderOptions.prototype.prefix;
}
/** @type {?} */
export const FIREBASE_REMOTE_CONFIG_PROVIDER_OPTIONS = new InjectionToken('FirebaseRemoteConfigProviderOptions');
//# sourceMappingURL=firebase-remote-config-provider-options.js.map